import _ from 'underscore'
import Vue from 'vue'
import NewsletterSub from '../../resources/newsletterSub'
import NewsletterUnSub from '../../resources/newsletterUnSub'

// This is an object where ads will be stored
// with keys as the id, and ad as the value
const state = {
}

const getters = {
  
}

const actions = {

  subscribe(context, payload) {
    NewsletterSub.save(payload.sub).then((res) => {
      context.commit('NEWSLETTER_SUBSCRIBE_SUCCESS');
      if (_.isFunction(payload.callback)) payload.callback(res.data);
    }, (errors) => {
      if (_.isFunction(payload.callback)) payload.callback(errors.data);
    });
  },

  // payload.ad
  unsubscribe(context, payload) {
    NewsletterUnSub.save(payload.sub).then((res) => {
      context.commit(`NEWSLETTER_UNSUBSCRIBE_SUCCESS`);
      if (_.isFunction(payload.callback)) payload.callback(res.data);
    }, (errors) => {
      if (_.isFunction(payload.callback)) payload.callback(errors.data);
    });
  },
}

const mutations = {

  NEWSLETTER_SUBSCRIBE_SUCCESS(state, payload) {
    
  },

  NEWSLETTER_UNSUBSCRIBE_SUCCESS(state, payload) {
    
  },

}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/newsletter-subs.js